import React, { Dispatch, SetStateAction } from 'react';
import { Dropdown } from 'react-bootstrap';

import { UseOutletContextInventory } from '../Inventory';
import { StateLanguage } from '../../../../languages/config/StateLanguage';
import { Category } from '../../../../models/category.model';
import { modalShow } from '../../../../tools/modal.tool';
import { categorySelected } from '../../../../scripts/list.selected.item.script';
import { legendValid } from '../../../../tools/legend.data.entry.tool';

import AppInventoryFormAccountingAccount from './InventoryFormAccountingAccount';
import AppModalCategoryCreate from '../../../../components/modal/ModalCategoryCreate';
import AppLegend from '../../../../components/element/Legend';

export interface AppInventoryFormDetailProps {
  inventory: string,
  action: string,
  category: {value: string, valid: boolean},
  accounts: {value: {expense: string, vat: string, product: string}, valid: {expense: boolean, vat: boolean, product: boolean}},
  setCategory: Dispatch<SetStateAction<{value: string, valid: boolean}>>,
  setAccounts: Dispatch<SetStateAction<{value: {expense: string, vat: string, product: string}, valid: {expense: boolean, vat: boolean, product: boolean}}>>
};

const AppInventoryFormDetail: React.FunctionComponent<AppInventoryFormDetailProps> = ({inventory, action, category, accounts, setCategory, setAccounts}) => {
  const {companyForUser, categoriesForCompany, accountingExpenseAccountsForCompany, accountingVatAccountsForCompany, accountingProductAccountsForCompany, setCategoriesForCompany} = UseOutletContextInventory()
  const {lang} = StateLanguage()

  const handleChangeCategory = (item: Category) => {
    setCategory({value: item.id, valid: true})
    setAccounts({value: {expense: item.accounts.expense, vat: item.accounts.vat, product: item.accounts.product}, valid: {expense: true, vat: true, product: true}})

    legendValid('legend-category-required')
    legendValid('legend-account-expense-required')
    legendValid('legend-account-vat-required')
    legendValid('legend-account-product-required')
  }

  const executeShowModalCategoryCreate = () => {
    modalShow('modal-category-create')
  }

  return (
    <>
      { companyForUser && categoriesForCompany && accountingExpenseAccountsForCompany && accountingVatAccountsForCompany && accountingProductAccountsForCompany &&
        <div className="card card-flush">
          <div className="card-header">
            <div className="card-title">
              <h3>{lang.labels[`${inventory}Details` as keyof typeof lang.labels]}</h3>
            </div>
          </div>
          <div className="card-body pt-0">
            <div className="d-flex flex-wrap justify-content-between align-items-end mb-2">
              <label className="form-label required">{lang.labels.category}</label>
              <button className="btn btn-light-primary btn-sm" type="button" onClick={executeShowModalCategoryCreate}>
                <div className="d-flex align-items-center">
                  <span className="svg-icon svg-icon-3 ms-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="black" />
                      <rect x="10.8891" y="17.8033" width="12" height="2" rx="1" transform="rotate(-90 10.8891 17.8033)" fill="black" />
                      <rect x="6.01041" y="10.9247" width="12" height="2" rx="1" fill="black" />
                    </svg>
                  </span>
                  {lang.labels.addCategory}
                </div>
              </button>
            </div>
            <Dropdown>
              <Dropdown.Toggle variant="select2 select2-container select2-container--bootstrap5 select2-container--below select2-container--focus select2-container--open w-100 p-0">
                <span className="selection">
                  <span className="select2-selection select2-selection--single form-select form-select-solid">
                    <span className="select2-selection__rendered" role="textbox">
                      {category.valid ? categorySelected(lang, categoriesForCompany, category.value) : lang.labels.selectOption}
                    </span>
                  </span>
                </span>
              </Dropdown.Toggle>
              <Dropdown.Menu variant="select2-container select2-container--bootstrap5 select2-container--open w-100">
                <span className="select2-dropdown select2-dropdown--below">
                  <span className="select2-results">
                    <ul className="select2-results__options" role="listbox">
                      <li className={`select2-results__option select2-results__option--selectable ${categoriesForCompany.length > 0 && "d-none"}`}>
                        <Dropdown.Item bsPrefix="select2-results__option__text">{lang.labels.selectOption}</Dropdown.Item>
                      </li>
                      { categoriesForCompany.map (( (item, index) => { return (
                        <li key={index} className={`select2-results__option select2-results__option--selectable ${item.id === category.value && "select2-results__option--selected"}`} role="option" aria-selected={item.id === category.value}>
                          <Dropdown.Item bsPrefix="select2-results__option__text" onClick={() => handleChangeCategory(item)}>{item.display_name}</Dropdown.Item>
                        </li>
                      )}))}
                    </ul>
                  </span>
                </span>
              </Dropdown.Menu>
            </Dropdown>
            <div className={`form-text text-justify ${action === "update" && "d-none"}`}>{lang.labels[`add${inventory.charAt(0).toUpperCase()}${inventory.slice(1)}ToCategory` as keyof typeof lang.labels]}</div>
            <AppLegend attribute={{check: category.valid, name: "category", index: null, sub_index: null}} container={{valid: false, required: true, identical: false, exists: false}}></AppLegend>            <div className="separator my-5"></div>
            <AppInventoryFormAccountingAccount accounts={accounts} setAccounts={setAccounts}></AppInventoryFormAccountingAccount>
          </div>
        </div>
      }
      <AppModalCategoryCreate companyForUser={companyForUser} categoriesForCompany={categoriesForCompany} accountingExpenseAccountsForCompany={accountingExpenseAccountsForCompany} accountingVatAccountsForCompany={accountingVatAccountsForCompany} accountingProductAccountsForCompany={accountingProductAccountsForCompany} category={category} setCategoriesForCompany={setCategoriesForCompany} setCategory={setCategory} setInventoryAccounts={setAccounts}></AppModalCategoryCreate>
    </>
  )
};

export default AppInventoryFormDetail;
